import { layoutOf } from "../../domain/layout";
import { dualAxle } from "../wheel-placements";
import { TRAILER_12, TRAILER_8 } from "./dimensions";
const trailerWheels = (d) => d.axleX.flatMap(
  (x, i) => dualAxle({
    axle: i + 1,
    x,
    radius: d.wheelRadius,
    width: d.tyreWidth,
    halfTrack: d.dualHalfTrack,
    spacing: d.dualSpacing
  })
);
const TRAILER_12_LAYOUT = layoutOf(["dual", "dual", "dual"]);
const TRAILER_12_WHEELS = trailerWheels(TRAILER_12);
const TRAILER_8_LAYOUT = layoutOf(["dual", "dual"]);
const TRAILER_8_WHEELS = trailerWheels(TRAILER_8);
export {
  TRAILER_12_LAYOUT,
  TRAILER_12_WHEELS,
  TRAILER_8_LAYOUT,
  TRAILER_8_WHEELS
};
